import React, { useEffect, useState } from 'react'
import { gsap } from 'gsap/dist/gsap';
import styles from "./section1.module.scss"
import bgImage from '../../../../public/images/home-section2.jpg';
import mbImage from '../../../../public/images/mobile/section2.jpg';
import buttonBg from '../../../../public/images/button-bg.png';
import SectionBg from '../sectionBg';
// Import Swiper Use
import { useSwiper, useSwiperSlide } from 'swiper/react';
import playClick from '../../actions/default-click';
import playHover from '../../actions/default-hover';
import Arrow from '../../icons/arrow';

function Section1() {
    const screenWidth = window.innerWidth;
    let pageBG = screenWidth < 767 ? mbImage : bgImage;
    const bgData = {
        bgImage: pageBG
    }
    const pageData = {
        title: 'נעים מאד,',
        content: "אנחנו רות ושרה.<br/>יש לנו סיפור מיוחד שאנחנו מתרגשות לספר. הוא מתחיל על האניה בדרך לארץ ישראל..."
    }
    // Swiper 
    const swiper = useSwiper();
    const swiperSlide = useSwiperSlide();
    // GSAP Split text
    useEffect(() => { 
        //console.log(swiperSlide);
        if(swiperSlide.isActive){
            if(screenWidth > 767) {
                gsap.set('#header', {xPercent: 100, opacity: 0}); 
                gsap.to('#header', {xPercent:0, opacity: 1, ease:"ease.in", duration: 1});
            }

            gsap.set('.ptitle', {y: 100, opacity: 0});
            gsap.set('.content', {y: 100, opacity: 0});   
            gsap.set('.button', {y: 100, opacity: 0});
            gsap.to('.ptitle', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0 })
            gsap.to('.content', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.2 })
            gsap.to('.button', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.4 })
        }
    }, [swiperSlide.isActive, screenWidth]);

  return (
    <>
        <SectionBg data={bgData} />
        <div className={`section-wrapper relative z-20 ${styles.wrapper}`}>
            <h2 className={`ptitle ${styles.title}`}>{pageData.title}</h2>
            <div className={`content ${styles.content}`} >
                <p dangerouslySetInnerHTML={{__html: pageData.content}}></p>
            </div>
            <div className={`button ${styles.magnetic}`}>
                <button 
                onClick={() => {
                    swiper.slideNext()
                    playClick();
                }}
                onMouseEnter={() => {
                  playHover();
                }}
                className={`${styles.button}`}>
                    <span className={styles.text}>לסיפור שלנו</span>
                    <span className={`flex items-center justify-center ${styles.icon}`} style={{backgroundImage: `url(${buttonBg.src})`}}>
                        <Arrow />
                    </span>
                </button>
            </div>
        </div>
    </>
  )
}

export default Section1